export interface Module {
  num: string
  title: string
  lines: string[]
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Ready-to-Teach Lesson Plan System™',
    lines: [
      'Complete lesson structures for different rider levels, technical objectives, private lessons, group lessons, skill development, and progressive teaching.',
    ],
  },
  {
    num: '2',
    title: 'Professional Exercise & Drill Library™',
    lines: [
      'Ready-to-use exercises for position, balance, seat, aids, steering, rhythm, transitions, coordination, accuracy, confidence, independence, pole work, and more.',
      'Each resource includes setup, execution, coaching cues, common errors, corrections, regressions, progressions, and next steps.',
    ],
  },
  {
    num: '3',
    title: 'Rider Progression Roadmaps™',
    lines: [
      'Structured development paths that help you decide what should come next.',
      'Use progression roadmaps for beginner, intermediate, and advanced riders, plus specific skill-development pathways.',
    ],
  },
  {
    num: '4',
    title: 'Arena Setups & Visual Training Cards™',
    lines: [
      'Professional visual arena layouts you can prepare and use directly.',
      'Pole layouts, cone patterns, steering courses, transition zones, accuracy setups, rhythm exercises, group layouts, and progressive variations.',
    ],
  },
  {
    num: '5',
    title: 'Rider Assessment & Lesson Decision System™',
    lines: [
      'Ready-to-use assessments, observation sheets, skill trackers, progress reviews, rider profiles, and decision maps.',
      'Quickly identify priorities and connect them with the right teaching focus.',
    ],
  },
  {
    num: '6',
    title: 'Complete Instructor Planning & Resource Kit™',
    lines: [
      'Professional planning tools, rider records, lesson planners, group trackers, progress sheets, multi-session planners, and complete development structures.',
      'Everything organized in one reusable system.',
    ],
  },
]

export const promises = [
  'Plan lessons faster',
  'Select exercises more easily',
  'Build rider progressions',
  'Adapt to different riders',
  'Organize arena work',
  'Track development',
]

export const systemIntro = [
  'Not a beginner riding course. Not basic theory. Not a random collection of exercises.',
  'A practical system created for experienced instructors who want ready-to-use professional material without spending hours preparing it.',
]
